import React, { useState } from 'react';
import { Heart, ShoppingCart, Star, Eye } from 'lucide-react';
import strings from '../../data/productCards.json';
import "./style.css";

// Простой переводчик
const useT = (lang = 'en') => (path) =>
  path.split('.').reduce((acc, k) => (acc ? acc[k] : undefined), strings[lang]) ?? '';

const ProductCardsDemo = ({ lang = 'en' }) => {
  const t = useT(lang);

  const [likedItems, setLikedItems] = useState(new Set());
  const [cartItems, setCartItems] = useState(new Set());
  const [viewCounts, setViewCounts] = useState({
    simple: 12,
    gradient: 28,
    neomorphic: 35
  });

  const products = [
    {
      id: 'simple',
      type: t('types.simple'),
      name: t('products.simple.name'),
      price: t('products.simple.price'),
      rating: 4.5,
      image: '🎧',
      className: 'simple-card'
    },
    {
      id: 'gradient',
      type: t('types.gradient'),
      name: t('products.gradient.name'),
      price: t('products.gradient.price'),
      rating: 4.8,
      image: '⌚',
      className: 'gradient-card'
    },
    {
      id: 'neomorphic',
      type: t('types.neomorphic'),
      name: t('products.neomorphic.name'),
      price: t('products.neomorphic.price'),
      rating: 4.7,
      image: '🔋',
      className: 'neomorphic-card'
    }
  ];

  const handleLike = (productId) => {
    const newLiked = new Set(likedItems);
    newLiked.has(productId) ? newLiked.delete(productId) : newLiked.add(productId);
    setLikedItems(newLiked);
  };

  const handleAddToCart = (productId) => {
    const newCart = new Set(cartItems);
    newCart.add(productId);
    setCartItems(newCart);

    // Симуляция: через 3 сек удаляем из корзины
    setTimeout(() => {
      const updatedCart = new Set(cartItems);
      updatedCart.delete(productId);
      setCartItems(updatedCart);
    }, 3000);
  };

  const handleView = (productId) => {
    setViewCounts((prev) => ({
      ...prev,
      [productId]: prev[productId] + 1
    }));
  };

  return (
    <div className="product-cards-demo">
      {products.map((product) => (
        <div
          key={product.id}
          className={`product-card ${product.className}`}
          onClick={() => handleView(product.id)}
        >
          <div className="product-card-header">
            <span className="card-type-label">{product.type}</span>
            <button
              className={`like-btn ${likedItems.has(product.id) ? 'liked' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                handleLike(product.id);
              }}
            >
              <Heart
                size={16}
                fill={likedItems.has(product.id) ? 'currentColor' : 'none'}
              />
            </button>
          </div>

          <div className="product-image">
            <span className="product-emoji">{product.image}</span>
          </div>

          <div className="product-info">
            <h4 className="product-name">{product.name}</h4>
            <div className="product-rating">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={12}
                  fill={i < Math.floor(product.rating) ? 'currentColor' : 'none'}
                  className="star"
                />
              ))}
              <span className="rating-text">{product.rating}</span>
            </div>
            <div className="product-price">{product.price}</div>
          </div>

          <div className="product-actions">
            <button
              className={`cart-btn ${cartItems.has(product.id) ? 'added' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                handleAddToCart(product.id);
              }}
            >
              <ShoppingCart size={14} />
              {cartItems.has(product.id)
                ? t('buttons.added')
                : t('buttons.addToCart')}
            </button>

            <div className="view-count">
              <Eye size={12} />
              <span>{viewCounts[product.id]}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductCardsDemo;
